import { OpportunityAgreementStatus } from "@freightsimple/generated-carriers-openapi-client/models/OpportunityAgreementStatus";
import { type OpportunitySummary } from "@freightsimple/generated-carriers-openapi-client/models/OpportunitySummary";

/**
 * Filtering the opportunity list, in the browser.
 *
 * The list is one row per published customer plus this carrier's own
 * agreements — tens of rows, not thousands — so a round-trip per keystroke
 * would be slower and no more correct.
 */

export const OPPORTUNITY_FILTERS = [
  { value: "all", label: "Everything" },
  { value: "open", label: "Open opportunities" },
  { value: "mine", label: "Yours" },
  { value: "covered", label: "In your service area" },
  { value: "expiring", label: "Expiring soon" },
];

export function matchesOpportunitySearch(
  opportunity: OpportunitySummary,
  search: string,
): boolean {
  const trimmed = search.trim().toLowerCase();
  if (trimmed === "") return true;
  return [opportunity.companyName, opportunity.narrative].some((field) =>
    field.toLowerCase().includes(trimmed),
  );
}

// "In your service area" is deliberately a majority test rather than "anything
// above zero": a carrier filtering for freight they can haul means most of it,
// not one lane in fifty.
const MAJORITY_COVERAGE = 0.5;

export function matchesOpportunityFilter(
  opportunity: OpportunitySummary,
  filter: string,
): boolean {
  switch (filter) {
    case "open":
      return opportunity.agreementStatus === OpportunityAgreementStatus.None;
    case "mine":
      return opportunity.agreementStatus !== OpportunityAgreementStatus.None;
    case "covered":
      return (opportunity.coveragePercentage ?? 0) >= MAJORITY_COVERAGE;
    case "expiring":
      return opportunity.expiringSoon === true;
    default:
      return true;
  }
}
